import { BoxShadow, Styles, ViewStyle } from '@bonanza-social/moonlight';
import { PrizeWallPrizeBackgroundVariant } from './PrizeWallPrizeBackground.types';

const BOX_SHADOW_DEFAULT: BoxShadow = [
  {
    offsetX: 0,
    offsetY: 1,
    blurRadius: 2,
    spreadDistance: 0,
    color: 'backdropSecondary',
  },
];

const BOX_SHADOW_SELECTED: BoxShadow = [
  {
    offsetX: 0,
    offsetY: 0,
    blurRadius: 24,
    spreadDistance: 0,
    color: 'backdropWarmUp',
  },
];

export const STYLES: Record<
  PrizeWallPrizeBackgroundVariant,
  Styles<ViewStyle>
> = {
  default: {
    boxShadow: BOX_SHADOW_DEFAULT,
    borderColor: 'borderPrimary',
    borderWidth: 'border-width-025',
    backgroundColor: 'primaryBackground',
  },
  focused: {
    boxShadow: BOX_SHADOW_SELECTED,
    borderColor: 'borderGoldSolid',
    borderWidth: 'border-width-050',
    backgroundColor: 'primaryBackground',
  },
  disabled: {
    boxShadow: BOX_SHADOW_DEFAULT,
    borderColor: 'borderPrimary',
    borderWidth: 'border-width-025',
    backgroundColor: 'tertiaryBackgroundHover',
    zIndex: 1,
  },
  missed: {
    boxShadow: BOX_SHADOW_DEFAULT,
    borderColor: 'borderError',
    borderWidth: 'border-width-025',
    backgroundColor: 'redBackground',
  },
  awarded: {
    boxShadow: BOX_SHADOW_SELECTED,
    borderColor: 'borderGoldSolid',
    borderWidth: 'border-width-050',
  },
};
